export const VIEW_FIELD_KEYS = {
	TRANSACTION_DETAILS: 'transactionDetails',
	TRANSACTION_ID: 'transactionId',
	MESSAGE: 'message',
	GAME_NAME: 'gameName',
	MATCH_NAME: 'matchName',
	RAZORPAY_PAYOUT_ID: 'razorpayPayoutId',
	RAZORPAY_PAYOUT_MSG: 'message',
	TRANSACTION_TYPE: 'transactionType',
	TOURNAMENT_ID: 'tournamentId',
	CGR_ID: 'cgrId',
	STATUS: 'status',
	// TICKETS_RAISED: 'tickets_raised',
	TRANSACTION_TIMESTAMP: 'transactionTimestamp',
	TRANSACTION_AMOUNT: 'transactionAmount',
	BONUS: 'bonus',
	WINNINGS: 'winnings',
	DEPOSIT: 'deposit',
	PAYMENT_DETAILS: 'paymentDetails',
	PAYMENTGATEWAY: 'paymentGateway',
	PAYMENT_GATEWAY_TRANSACTION_ID: 'paymentGatewayTransactionId',
	GATEWAY_TRANSACTION_ID: 'gatewayTransactionId',
	PAYMENT_METHOD: 'paymentMethod',
	COUPONS_USED: 'couponsUsed',
	COUPON_ID: 'couponId',
	COINS_ADDED_TID: 'originalTid',
	HOOK_TIMESTAMP: 'hookTimestamp',
	ORDER_AMOUNT: 'orderAmount',
	CLEARANCE_AMOUNT: 'clearanceAmount',
	PAYMENT_STATUS: 'paymentStatus',
	PAYMENT_TRANSACTION_TIMESTAMP: 'paymentTransactionTimestamp',
	CASHBACK: 'cashback',
	GST_TRANSACTION_ID: 'gstTransactionId',
	DEPOSIT_TRANSACTION_ID: 'depositTxnId',
	GST_AMOUNT: 'gstAmount',
	PG_AMOUNT: 'pgAmount',
	UPDATED_AT: 'updatedAt'
};
